var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDestinationMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 27,
    viewBox: "0 0 19 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8782 16.4137C17.0129 14.7305 18.3833 12.1211 18.3833 9.19167C18.3833 4.11525 14.2681 0 9.19167 0C4.11525 0 0 4.11525 0 9.19167C0 12.6688 1.93078 15.695 4.7787 17.2567C5.206 17.6855 5.7558 18.3109 6.40083 19.204C8.53461 22.1585 9.19127 26.5902 9.19127 26.5902C9.19127 26.5902 10.0118 21.6661 12.1456 19.0399C14.1153 16.9061 14.9359 16.4137 14.9359 16.4137H14.8782Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinationMarker);
export default __webpack_public_path__ + "static/media/destination-marker.81158fc2738d190ef9b4b4bbd72d7913.svg";
export { ForwardRef as ReactComponent };